import { Button } from '../ui/button';

/**
 * One thing analysis found that the person can confirm or ignore, shown
 * inside the section it belongs to (a home under "Where you lived", a
 * person under "The people who were there"). `actions` are the confirm
 * buttons, most likely first; Ignore is always last and quiet.
 */
export const SuggestionRow = ({ title, detail, actions = [], onIgnore, disabled, testId }) => (
  <div className="rounded-lg bg-surface px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3" data-testid={testId}>
    <div className="min-w-0 flex-1">
      <p className="text-[15px] font-medium text-ink">{title}</p>
      {detail && <p className="text-sm text-ink-55">{detail}</p>}
    </div>
    <div className="flex flex-wrap items-center gap-2 shrink-0">
      {actions.map((a) => (
        <Button key={a.label} size="sm" variant="secondary" disabled={disabled} onClick={a.onClick} data-testid={a.testId}>{a.label}</Button>
      ))}
      {onIgnore && <Button size="sm" variant="ghost" disabled={disabled} onClick={onIgnore} data-testid={testId ? `${testId}-ignore` : undefined}>Not right</Button>}
    </div>
  </div>
);

/** The amber "found in your records" box a section's suggestions sit in. */
export const FoundBox = ({ title = 'Found in your records', children, testId }) => (
  <div className="rounded-lg bg-amber-wash p-4 space-y-2.5" data-testid={testId}>
    <p className="pd-eyebrow text-amber-ink">{title}</p>
    {children}
  </div>
);

export default SuggestionRow;
